import { useContext } from 'react';
import { StoreContext } from '../_store';

export const useStore = () => {
    const store = useContext(StoreContext);
    return store;
};
